<div id="imageoneHome" *ngIf="imageoneHome">
	<imageone-home [pageDisplay]="pageDisplay" [pageTitle]="pageTitle"></imageone-home>
</div>